// extracted by mini-css-extract-plugin
export var faqSection = "faq-module--faqSection--wdGZ7";
export var heading = "faq-module--heading--Gmc7I";
export var mainSection = "faq-module--mainSection--aYnoI";
export var text = "faq-module--text---r1Ca";